<ng-container *ngIf="notifications.notifications() | async as lookatme">
   <button mat-icon-button style="margin: 0 0.5em;">
      <mat-icon [matBadge]="lookatme.length">notifications</mat-icon>
   </button>
</ng-container>
